import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerListadoRegistrosTdr = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Informe/ListaRegistrosTdr",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { ObtenerListadoRegistrosTdr };
